import React from 'react'

import facebook from '../../../../content/icons/facebook.svg'
import instagram from '../../../../content/icons/instagram.svg'

export const Facebook = ({ ...other }) => <img {...other} src={facebook} alt={other.alt} />

export const Instagram = ({ ...other }) => <img {...other} src={instagram} alt={other.alt} />
